import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InfoIcon from "@material-ui/icons/Info";
import { useTranslation } from "react-i18next";
import Tooltip from '@material-ui/core/Tooltip';
import SettingsService from "../../../../services/SettingsService/SettingsService";
import { validateEmail } from "../../../../helpers/helper";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import "./MailServer.css";

function MailServer(props) {
  const { t } = useTranslation();
  const [type, setType] = useState("SMTP");
  const [enable, setEnable] = useState(true);
  const [auth, setAuth] = useState(false);
  const [testMail, setTestMail] = useState("");
  const [host, setHost] = useState("");
  const [fromMail, setFrom] = useState("");
  const [port, setPort] = useState("");
  const [sender, setSender] = useState("");
  const [disableSendMail, setDisableSendMail] = useState(false);
  const [values, setValues] = useState({
    username: "",
    password: "",
    showPassword: false,
  });
  const setAlert = useSetRecoilState(alertState);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await SettingsService.getMail();
    if (res?.status) {
      setEnable(res.data.is_tls);
      setType(res.data.protocol);
      setFrom(res.data.from);
      setPort(res.data.port);
      setHost(res.data.host);
      setSender(res.data.sender_name);
      setValues({ id: res.data.id, username: res.data.user, password: res.data.password });
    }
  }

  const handleSave = async () => {
    await SettingsService.postMail({
      is_tls: enable,
      protocol: type,
      from: fromMail,
      port, host,
      sender_name: sender,
      username: values.username,
      password: values.password,
      id: values.id
    })
  }

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSendTestMail = async () => {
    const response = await SettingsService.sendMail({ mailAddress: testMail })
    if (response) {
      //successfully
      if (response?.status) {
        setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.SETTINGS.MAIL-SERVER.TEST-MAIL-SUCCESS'), severity: 'success' }));
      }
    } else {
      setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
    }
  }
  const handleChangeMailInput = (event) => {
    if (validateEmail(event.target.value)) {
      setTestMail(event.target.value)
      setDisableSendMail(false);
    } else {
      setDisableSendMail(true);
    }
  }
  return (
    <div className="sgeneral">
      <div>{t("CONTENT.SETTINGS.MAIL-SERVER.MAIL-SERVER")}</div>
      <Grid container spacing={4}>
        <Grid item xs={12} lg={6}>
          <div className="mail-server-text">
            {t("CONTENT.SETTINGS.MAIL-SERVER.SERVER-NAME")}*
          </div>
          <div className="mail-server-line" />
          <div className="mail-server-input-text">
            <input type="text" value={host} onChange={(e) => { setHost(e.target.value) }} />
          </div>
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="mail-server-text">
            {t("CONTENT.SETTINGS.MAIL-SERVER.PORT-SSL")}*
          </div>
          <div className="mail-server-line" />
          <div className="mail-server-input-text">
            <input type="number" value={port} onChange={(e) => { setPort(e.target.value) }} />
          </div>
          <small className="mail-server-small-text">{t("CONTENT.SETTINGS.MAIL-SERVER.DEFAULT-VALUE")}: 25</small>
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="mail-server-text">
            {t("CONTENT.SETTINGS.MAIL-SERVER.SENDER-NAME")}
          </div>
          <div className="mail-server-line" />
          <div className="mail-server-input-text">
            <input type="text" value={sender} onChange={(e) => { setSender(e.target.value) }} />
          </div>
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="mail-server-text">
            {t("CONTENT.SETTINGS.MAIL-SERVER.SENDER-MAIL")}*
          </div>
          <div className="mail-server-line" />
          <div className="mail-server-input-text">
            <input type="text" value={fromMail} onChange={(e) => { setFrom(e.target.value) }} />
          </div>
        </Grid>
        <Grid item xs={12} lg={6} style={{ margin: "20px 0 20px 0" }}>
          <div className="mail-server-head-list">
            <div className="mail-server-text">
              {t("CONTENT.SETTINGS.MAIL-SERVER.MAIL-TYPE")}
              <Tooltip title="lorem ipsum" placement="top"><InfoIcon className="mail-server-info" /></Tooltip>
            </div>
            <div className="mail-server-text">
              {t("CONTENT.SETTINGS.MAIL-SERVER.ENABLE-TLS")}
              <Tooltip title="lorem ipsum" placement="top"><InfoIcon className="mail-server-info" /></Tooltip>
            </div>
          </div>
          <div className="mail-server-line" />
          <div className="mail-server-head-list">
            <div className="mail-server-button-group">
              <div
                onClick={() => setType("SMTP")}
                className={
                  type === "SMTP"
                    ? "mail-server-button-active"
                    : "mail-server-button"
                }
              >
                {t("CONTENT.SETTINGS.MAIL-SERVER.SMTP")}
              </div>
              <div
                onClick={() => setType("SMTPS")}
                className={
                  type === "SMTPS"
                    ? "mail-server-button-active"
                    : "mail-server-button"
                }
              >
                {t("CONTENT.SETTINGS.MAIL-SERVER.SMTPS")}
              </div>
            </div>
            <div className="mail-server-button-group">
              <div
                onClick={() => setEnable(true)}
                className={
                  enable === true
                    ? "mail-server-button-active"
                    : "mail-server-button"
                }
              >
                {t("CONTENT.SETTINGS.MAIL-SERVER.YES")}
              </div>
              <div
                onClick={() => setEnable(false)}
                className={
                  enable === false
                    ? "mail-server-button-active"
                    : "mail-server-button"
                }
              >
                {t("CONTENT.SETTINGS.MAIL-SERVER.NO")}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} style={{ margin: "20px 0 20px 0" }}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={auth}
                onClick={() => setAuth(!auth)}
                style={{ color: auth && "#43AA41" }}
              />
            }
            label={
              <div className="mail-server-checkbox-label">
                {t("CONTENT.SETTINGS.MAIL-SERVER.REQUIRED-AUTH")}
              </div>
            }
          />
        </Grid>
        {auth === true && (
          <>
            <Grid item xs={12} lg={6} >
              <div className="mail-server-text">

                {t("CONTENT.SETTINGS.MAIL-SERVER.USERNAME")}
              </div>
              <div className="mail-server-line" />
              <div className="mail-server-input-text">
                <input type="text" value={values.username} onChange={handleChange("username")} />
              </div>
            </Grid>
            <Grid item xs={12} lg={6}>
              <div className="mail-server-text">
                {t("CONTENT.SETTINGS.MAIL-SERVER.PASSWORD")}
              </div>
              <div className="mail-server-line" />
              <div className="mail-server-focused">
                <OutlinedInput
                  className="mail-server-input-text-input"
                  type={values.showPassword ? "text" : "password"}
                  value={values.password}
                  onChange={handleChange("password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
            </Grid>
          </>
        )}
        <Grid item xs={12} lg={6} spacing={4} style={{ marginTop: auth && 10, marginBottom: auth && 10 }}>
          <div className="mail-server-text">
            {t("CONTENT.SETTINGS.MAIL-SERVER.TEST-MAIL")}*
          </div>
          <div className="mail-server-line" />
          <div
            style={{ marginTop: 16, marginBottom: 11 }}
            className="mail-server-input-text"
          >
            <input type="text" onChange={handleChangeMailInput} />
          </div>
          <small onClick={handleSendTestMail} style={{ pointerEvents: testMail.length <= 1 || disableSendMail ? "none" : "auto" }} className="mail-server-small-text-link">
            {t("CONTENT.SETTINGS.MAIL-SERVER.SEND-TEST-MAIL")}
          </small>
        </Grid>
        <Grid item xs={12} style={{ margin: "20px 0 20px 0" }}>
          <div className="mail-server-bottom-section">
            <div className="mail-server-button-save" onClick={handleSave}>
              {t("CONTENT.SETTINGS.MAIL-SERVER.SAVE")}
            </div>
            <div className="mail-server-button-cancel">
              {t("CONTENT.SETTINGS.MAIL-SERVER.CANCEL")}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
export default MailServer;